import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";

import { AuthguardService } from './authguard.service'
@Injectable({
  providedIn: 'root'
})



export class AuthenticationGuard implements CanActivate {

  constructor(
    private auth: AuthguardService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      const currentUser = this.auth.gettoken();
      if (currentUser) {
        return true;
      }

      this.router.navigate(['/testLogin'], { queryParams: { returnUrl: state.url } });
      return false;

    // const token = this.auth.getToken();
    // const url = "/token/verify/";

    // if (!token) {
    //   this.router.navigate(["/login"]);
    //   return false;
    // }

    // return this.auth.verifyToken().pipe(
    //   tap((allowed: any) => {
    //     if (!allowed) this.router.navigate(["/login"]);
    //   })
    // );

    return true;
  }

  // canActivate(): boolean  {
  //   return true;
  // }

}
